/* 🤖 this file was generated by svg-to-ts*/
export const icoHeart: {
  name: 'heart';
  data: string;
} = {
  name: 'heart',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.75 3.006c-1.584.076-3.114.872-4.592 2.339l-.158.16-.158-.16C10.286 3.8 8.673 3 7 3 3.576 3 2 5.206 2 9c0 4.098 3.212 8.024 9.479 11.853a1 1 0 001.043 0C18.788 17.023 22 13.098 22 9c0-4.104-1.459-6-5-6l-.25.006zM17 5c2.305 0 3 .904 3 4l-.004.216c-.116 3.027-2.663 6.202-7.77 9.464l-.227.142-.225-.142C6.546 15.34 4 12.092 4 9c0-2.806.853-4 3-4 1.325 0 2.738.847 4.232 2.64l.768.922.768-.922C14.262 5.847 15.675 5 17 5z" fill="#909090"/></svg>`
};
